import backGroundImage from '../Assets/signupbck.jpg'
const SignUpForm = () => {

    return (
        <div id='signupform' className="w-screen h-screen flex items-center justify-evenly text-white  bg-cover overflow-hidden" style={{ backgroundImage: `url(${backGroundImage})` }}>
            <div className="w-4/12 h-auto p-0  rounded shadow-3xl text-[14px] z-20 flex-column items-center justify-center max-lg:w-11/12" >
                <div
                    className="w-1/1 h-auto p-6 bg-white text-[#1b1b1b] rounded shadow-xl border-none flex items-center justify-center flex-col m-0">
                    <h1 className="w-full text-center text-3xl font-bold p-3">Sign Up Form</h1>
                    <input className="w-full p-2 m-2 border-zinc border-[1px] rounded" type="text" placeholder="Name"
                           name='name'></input>
                    <input className="w-full p-2 m-2 border-zinc border-[1px] rounded" type="text"
                           placeholder="LastName" name='lastname'></input>
                    <input className="w-full p-2 m-2 border-zinc border-[1px] rounded" type="email" placeholder="Email"
                           name='email'></input>
                    <input className="w-full p-2 m-2 border-zinc border-[1px] rounded" type="password"
                           placeholder="Password" name='password'></input>
                    <input className="w-full p-2 m-2 border-zinc border-[1px] rounded" type="password"
                           placeholder="ConfirmPassword" name='confirmpassword'></input>
                    <h5 className="w-full text-center text-l font-bold p-2 bg-blue-400 rounded text-white">Property
                        Code</h5>
                    <input className="w-full p-2 m-2 border-zinc border-[1px] rounded" type="text" placeholder="Code"
                           name='code'></input>
                    <select
                        className="w-full p-2 m-2 border-zinc border-[1px] rounded"
                        name="code"
                        defaultValue="">
                        <option value="" disabled selected className={'text-red-500'}>
                            Pick outlet
                        </option>
                    </select>

                    <button
                        className="duration-300 bg-green-600 m-2 hover:bg-green-900 text-white font-bold py-2 px-4 rounded paddong-5">Send
                        Sign Up Request
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SignUpForm